import dynamic from "next/dynamic";

// Client only: games use WebSocket, canvas and localStorage.
const DrawGame = dynamic(() => import("../DrawGame/DrawGame").then((m) => m.DrawGame), { ssr: false });
const ColorGame = dynamic(() => import("../ColorGame/ColorGame").then((m) => m.ColorGame), { ssr: false });

/**
 * Game UI per catalog slug (mini_games.slug). One component renders every mode:
 *  - host:    /mini-games/<slug>                       (streamer)
 *  - overlay: /widgets/mini-games/<slug>?streamKey=…   (OBS)
 *  - play:    /<username>/mini-games/<slug>/play       (ticket holders)
 * A new game = a new entry here. Slugs must not clash with the static pages next to
 * these routes ("order", "alert").
 */
const MINI_GAME_COMPONENTS = {
  "draw-to-guess": DrawGame,
  "recreate-the-color": ColorGame,
};

// Games with a how-to page (src/pages/docs/mini-games/[slug].js).
const MINI_GAME_DOCS_SLUGS = ["draw-to-guess", "recreate-the-color"];

const MINI_GAME_SLUGS = Object.keys(MINI_GAME_COMPONENTS);

export { MINI_GAME_COMPONENTS, MINI_GAME_DOCS_SLUGS, MINI_GAME_SLUGS };
